exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer[data-v-ff7dcfe4]{width:100%;height:50px;font-size:1.4rem;display:block;position:fixed;color:#fff;background-color:rgba(0,0,0,.05);padding:.3em 0 .5em;bottom:0;text-align:center;border-top:3px solid rgba(0,0,0,.1)}footer>_div[data-v-ff7dcfe4]{display:block;width:100%;max-width:calc(1280px + 2.5%);margin:auto;padding-left:15px}.fk-adress[data-v-ff7dcfe4]{font-size:1.3rem}.fk-flleft[data-v-ff7dcfe4]{padding:0 .5%;float:left;display:block;margin-right:1.5rem}.fk-flleft>p[data-v-ff7dcfe4]{padding:0;margin:0}.fk-flleft>p>i[data-v-ff7dcfe4]{vertical-align:middle}footer .footer-copyright[data-v-ff7dcfe4]{margin-left:32px;font-size:1.2rem;color:rgba(0,0,0,.5)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ff7dcfe4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Footer.vue
// module id = 280
// module chunks = 0